import React, { useEffect, useRef, useState } from "react";
import "../../App.css";
import { init } from "../../api/members/members";
import Steps1 from "./Steps1";
import Steps2 from "./Steps2";
import Steps3 from "./Steps3";
import Steps4 from "./Steps4";
import Steps5 from "./Steps5";
import Steps6 from "./Steps6";

const SignUp = () => {
 const [count, setCount] = useState(1);
  const [formData, setFormData] = useState({});
  const [initialData, setInitialData] = useState("");
  const [completedSteps, setCompletedSteps] = useState([]);
  const stepRefs = useRef([]);

  // let aimsUserIdToken = localStorage.getItem("aimsUserMemberId");

  // API call to fetch data
  const fetchData = async () => {
    try { 
      const response = await init(); //axios method 
      setInitialData(response?.data); // Store API data in formData
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  // Scroll to the active step when `count` changes
  // useEffect(() => {
  //   if (stepRefs.current[count - 1]) { // Adjust index for array
  //     stepRefs.current[count - 1].scrollIntoView({
  //       behavior: "smooth",
  //       inline: "center",
  //       block: "nearest",
  //     });
  //   }
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, [count]);

  window.scrollTo(0, 0);

  const handelDetails = (data) => {
    setFormData({ ...formData, ...data });
  };

  const handleStep = (step) => {
    if (completedSteps.includes(step) || step <= count) {
      setCount(step);
    }
  };

  const completeCurrentStep = (currentStep) => {
    if (!completedSteps.includes(currentStep)) {
      setCompletedSteps([...completedSteps, currentStep]);
    }
  };

  console.log("Current Step:", count);
  console.log("Form Data:", formData);

  return (
    <div>
      <br />

      <div>
        <div
          className=" dashboard  hide col-sm-10   col-11 d-flex align-items-start m-auto justify-content-between position-relative"
          style={{ color: "#034DA2", columnGap: "50px", overflowX: "auto" }}
        >
          <div
            className="line"
            style={{
              position: "absolute",
              top: "25px",
              left: "25px",
              width: "96%",
              height: "2px",
              background: "#AEC4E0",
            }}
          >
            <div
              style={{
                width: `${(Math.max(...completedSteps, count - 1) / 5) * 100}%`,
                height: "2px",
                background: "#034DA2",
              }}
            ></div>
          </div>

          {/* Step Indicators */}
          {[1, 2, 3, 4, 5, 6].map((step) => (
            <div
              key={step}
              ref={(el) => (stepRefs.current[step - 1] = el)}
              className="d-flex align-items-center justify-content-center z-1"
              onClick={() => handleStep(step)}
              style={{ cursor: "pointer" }}
            >
              <div>
                <div
                  className={`progressStatus ${completedSteps.includes(step) || count >= step ? "active" : ""
                    }`}
                >
                  {step < 10 ? `0${step}` : step}
                </div>
                <p className="d-flex justify-content-center mb-0"></p>
                <b className="responsive-hide wrap mt-2">
                  {step === 1 && "Contact Info"}
                  {step === 2 && "Basic Details"}
                  {step === 3 && "Address Info"}
                  {step === 4 && "Education/Occupation Info"}
                  {step === 5 && "Mandal Info"}
                  {step === 6 && "Seva Skill"}
                </b>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="col-11 m-auto">
        {count === 1 && (
          <Steps1
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData} // Pass formData (which includes initialData)
          />
        )}
        {count === 2 && (
          <Steps2
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData} // Pass updated formData
            initialData={initialData} // You can still pass initialData separately if needed
          />
        )}
        {count === 3 && (
          <Steps3
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
          />
        )}
        {count === 4 && (
          <Steps4
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
        {count === 5 && (
          <Steps5
            completeCurrentStep={completeCurrentStep}
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
        {count === 6 && (
          <Steps6
            count={count}
            setCount={setCount}
            detailsSet={handelDetails}
            details={formData}
            initialData={initialData}
          />
        )}
      </div>

      <br />
    </div>
  );
};

export default SignUp;